import { checkout } from '../services/checkout';

const BuyNowButton = ({ productPriceId }) => {
  return (
    <button type='button' onClick={() => checkout(productPriceId)}>
      Buy Now
    </button>
  );
};

export default BuyNowButton;
